import React, { memo } from 'react'
import { formFieldPropTypes } from './propTypes'

const FormField = ({
  Component,
  field,
  fields,
  onFocusField,
  onBlurField,
  onDisableField,
  onEnableField,
  onSetFieldValue
}) => {
  const { name } = field

  return (
    <Component
      field={field}
      onChange={(value) => onSetFieldValue(name, value)}
      onFocus={() => onFocusField(name)}
      onBlur={() => onBlurField(name)}
      onDisable={() => onDisableField(name)}
      onEnable={() => onEnableField(name)}
      fields={fields}
    />
  )
}

FormField.propTypes = formFieldPropTypes

export default memo(FormField)
